'use strict';

module.exports = {
    url: 'https://fagelaventyret.netlify.com',
    title: 'Fågeläventyret',
    subtitle: '300 svenska fåglar',
};